<template>
  <!-- modal cadastro assinatura por boleto avulso -->
  <b-modal id="modal-cadastrar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Cadastrar assinatura</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-list"></i>Dados do aluno</h6>
      <div class="row">
        <div class="col-12 col-md-6">
          <form-group label="Email *" :text="{ required: 'Obrigatório informar o email' }" :field="$v.assinatura.email">
            <div class="input-group">
              <input ref="email" v-on:keyup.enter="buscaAluno" type="text" class="form-control" id="email" placeholder="Informe o email para busca e tecle <enter>" v-model="assinatura.email" />
              <i class="fas fa-search" style="margin-top:10px; margin-left:5px; font-size:large;" @click="buscaAluno"/>
            </div>
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group  label="Nome" :text="{ required: 'Obrigatório informar o nome' }" :field="$v.assinatura.dadosPessoais.nome">
            <input type="text" class="form-control" id="nome" placeholder="" v-model="assinatura.dadosPessoais.nome" />
          </form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <form-group label="CPF" :field="$v.assinatura.dadosPessoais.cpf" :text="{ required: 'Campo obrigatório', minLength: 'Tamanho inválido' }">
            <input type="text" class="form-control" id="cpf" placeholder="" v-mask="['###.###.###-##']" v-model="assinatura.dadosPessoais.cpf" />
          </form-group>
        </div>

        <div class="col-12 col-md-6">
          <form-group label="Telefone" :text="{ required: 'Obrigatório informar o telefone', minLength: 'Tamanho inválido' }" :field="$v.assinatura.dadosPessoais.telefone">
            <input type="text" v-mask="['+55 (##) ####-####', '+55 (##) #####-####']" class="form-control" id="telefone" placeholder="" v-model="assinatura.dadosPessoais.telefone" />
          </form-group>
        </div>

      </div>

      <h6><i class="fas fa-list"></i>Endereço</h6>
        <div class="row">
          <div class="col-12 col-md-3">
            <form-group label="CEP" :text="{ required: 'Obrigatório informar o cep',  minLength: 'Tamanho inválido' }" :field="$v.assinatura.endereco.cep">
              <input type="text" v-mask="['##.###-###']" class="form-control" id="cep" placeholder="" v-model="assinatura.endereco.cep" />
            </form-group>
          </div>

          <div class="col-12 col-md-5">
            <form-group label="Rua" :text="{ required: 'Obrigatório informar a rua' }" :field="$v.assinatura.endereco.rua">
              <input type="text" class="form-control" id="rua" placeholder="" v-model="assinatura.endereco.rua" />
            </form-group>
          </div>

          <div class="col-12 col-md-2">
            <form-group label="Número" :text="{ required: 'Obrigatório informar o numero' }" :field="$v.assinatura.endereco.numero">
              <input type="text" class="form-control" id="numero" placeholder="" v-model="assinatura.endereco.numero" />
            </form-group>
          </div>

          <div class="col-12 col-md-2">
            <form-group label="Complemento" :text="{ required: 'Obrigatório informar o complemento' }" :field="$v.assinatura.endereco.complemento">
              <input type="text" class="form-control" id="complemento" placeholder="" v-model="assinatura.endereco.complemento" />
            </form-group>
          </div>

        </div>

        <div class="row">

          <div class="col-12 col-md-5">
            <form-group label="Bairro" :text="{ required: 'Obrigatório informar o bairro' }" :field="$v.assinatura.endereco.bairro">
              <input type="text" class="form-control" id="bairro" placeholder="" v-model="assinatura.endereco.bairro" />
            </form-group>
          </div>

          <div class="col-12 col-md-2">
            <form-group label="Estado" :text="{ required: 'Obrigatório informar o estado' }" :field="$v.assinatura.endereco.estado">
               <select class="form-control" v-model="assinatura.endereco.estado">
                  <option v-for="uf in ufs" :value="uf.id" :key="uf.id">
                    {{ uf.sigla }}
                  </option>
                </select>
            </form-group>
          </div>

          <div class="col-12 col-md-5">
            <form-group label="Cidade" :text="{ required: 'Obrigatório informar a cidade' }" :field="$v.assinatura.endereco.cidade">
              <input type="text" class="form-control" id="cidade" placeholder="" v-model="assinatura.endereco.cidade" />
            </form-group>
          </div>

        </div>

      <h6><i class="far fa-calendar-alt"></i> Dados da assinatura</h6>
      <div class="error" v-if="$v.validationOpcoes.$error" style="color:red;">Obrigatório informar um plano.</div>
      <div class="row mt-2">
        <div class="col-12 col-md-4">
          <div style="font-size:16px;"><strong>Jaleko Pro</strong></div>
          <form-group :field="$v.opcoes.optPro" class="mt-2 ml-3">
            <div v-for="(plano, index) in jalekoPro" :key="plano.id">
              <label>
                <input type="checkbox" :value="plano.id" :id="'pro_'+plano.id" v-model="optJalekoPro[index]"
                @change="checkPlano(index,'optJalekoPro', 'optPro', $event)"
                style="transform: scale(1.2); margin-right:5px;margin-bottom:5px;">{{duracao(plano.plano)}}
              </label>
            </div>
            <input type="hidden" v-model="optPro">
          </form-group>
        </div>
        <div class="col-12 col-md-4">
          <div style="font-size:16px;"><strong>Jaleko Plantonista</strong></div>
          <form-group :field="$v.opcoes.optPlanto" class="mt-2 ml-3" >
            <div v-for="(plano, index) in jalekoPlantonista" :key="plano.id">
              <label>
                <input type="checkbox" :value="plano.id" :id="'planto_'+plano.id" v-model="optJalekoPlantonista[index]"
                @change="checkPlano(index,'optJalekoPlantonista', 'optPlanto', $event)"
                style="transform: scale(1.2);margin-right:5px;margin-bottom:5px;">{{duracao(plano.plano)}}
              </label>
            </div>
            <input type="hidden" v-model="optPlanto">
          </form-group>
        </div>
        <div class="col-12 col-md-4">
          <div style="font-size:16px;"><strong>Jaleklínico</strong></div>
          <form-group :field="$v.opcoes.optKlinico" class="mt-2 ml-3" >
            <div v-for="(plano, index) in jaleklinico" :key="plano.id">
              <label>
                <input type="checkbox" :value="plano.id" :id="'klin_'+plano.id" v-model="optJaleklinico[index]"
                @change="checkPlano(index,'optJaleklinico', 'optKlinico', $event)"
                style="transform: scale(1.2);margin-right:5px;margin-bottom:5px;"> {{duracao(plano.plano)}}
              </label>
            </div>
            <input type="hidden" v-model="optKlinico">
          </form-group>
        </div>
      </div>

      <h6><i class="far fa-calendar-alt"></i> Acesso</h6>
      <div class="row">
        <div class="col-12 col-md-6">
            <input v-if="isSafari" type="date" v-mask="['##/##/####']" class="form-control" id="dataAcessoInicio" placeholder="dd/mm/aaaa" v-model="assinatura.dataAcessoInicio" />
            <input v-else type="date" class="form-control" id="dataAcessoInicio" placeholder="" v-model="assinatura.dataAcessoInicio" />
        </div>
        <div class="col-12 col-md-6">
            <input v-if="isSafari" type="date" v-mask="['##/##/####']" class="form-control" id="dataAcessoFim" placeholder="dd/mm/aaaa" v-model="assinatura.dataAcessoFim" />
            <input v-else type="date" class="form-control" id="dataAcessoFim" placeholder="" v-model="assinatura.dataAcessoFim" />
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 col-md-6">
          <label for="liberaApos" style="font-size:16px">
            <input id="liberaApos" style="margin-right:5px;" name="liberaAutomaticamente" v-model="assinatura.liberaAutomaticamente"  v-bind:value="false" type="radio">Liberar acesso após o pagamento do boleto
          </label>
        </div>
        <div class="col-12 col-md-6">
          <label for="liberaAutomaticamente" style="font-size:16px;">
            <input id="liberaAutomaticamente" style="margin-right:5px;" name="liberaAutomaticamente" v-model="assinatura.liberaAutomaticamente"  v-bind:value="true" type="radio">Liberar acesso automaticamente
          </label>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="gerarBoletoAvulso" >Criar assinatura por boleto</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import AssinaturaAPI from '@/api/assinatura-api'
import UsuarioAPI from '@/api/usuario-api'
import { required, requiredIf, minLength } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'ModalCadastroAssinatura',
  components: { FormGroup },
  props: {
    planos: Array,
    ufs: Array
  },
  data () {
    return {
      assinatura: {
        email: '',
        dadosPessoais: {
          nome: '',
          cpf: null,
          telefone: ''
        },
        endereco: {
          cep: null,
          rua: '',
          numero: null,
          complemento: '',
          bairro: '',
          estado: '',
          cidade: '',
          pais: 'BR'

        },
        planosIds: [],
        // cupom: null,
        liberaAutomaticamente: null,
        dataAcessoInicio: '',
        dataAcessoFim: ''
      },
      jalekoPro: Array,
      jalekoPlantonista: Array,
      jaleklinico: Array,
      optJalekoPro: [],
      optJalekoPlantonista: [],
      optJaleklinico: [],
      optPro: null,
      optPlanto: null,
      optKlinico: null
    }
  },

  computed: {
    isSafari: function () {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('safari') !== -1) {
        if (ua.indexOf('chrome') > -1) {
          return false
        } else {
          return true
        }
      }
      return false
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      this.assinatura = {
        email: '',
        dadosPessoais: {
          nome: '',
          cpf: null,
          telefone: ''
        },
        endereco: {
          cep: null,
          rua: null,
          numero: null,
          complemento: null,
          bairro: null,
          estado: null,
          cidade: null,
          pais: 'BR'
        },
        planosIds: [],
        liberaAutomaticamente: false
      }

      this.optJalekoPro = []
      this.optJalekoPlantonista = []
      this.optJaleklinico = []

      this.planos.forEach(item => {
        if (item.id === 3) {
          this.jalekoPro = item.planos
          this.jalekoPro.forEach(plano => {
          })
        } else if (item.id === 4) {
          this.jalekoPlantonista = item.planos
        } else if (item.id === 35) {
          this.jaleklinico = item.planos
        }
      })
    })
  },

  validations: {
    assinatura: {
      email: { required },
      dadosPessoais: {
        nome: { required },
        cpf: { required, minLength: minLength(14) },
        telefone: { required, minLength: minLength(18) }
      },
      endereco: {
        cep: { required, minLength: minLength(10) },
        rua: { required },
        numero: { required },
        complemento: { },
        bairro: { required },
        estado: { required },
        cidade: { required },
        liberaAutomaticamente: { }
      }
    },
    opcoes: {
      optPro: { required: requiredIf(function () {
        return this.optPlanto == null && this.optKlinico == null && this.optPro == null
      })
      },
      optPlanto: { required: requiredIf(function () {
        return this.optPlanto == null && this.optKlinico == null && this.optPro == null
      })
      },
      optKlinico: { required: requiredIf(function () {
        return this.optPlanto == null && this.optKlinico == null && this.optPro == null
      })
      }
    },
    validationOpcoes: ['opcoes.optPro', 'opcoes.optPlanto', 'opcoes.optKlinico']
  },

  methods: {
    show: function () {
      this.optPro = null
      this.optPlanto = null
      this.optKlinico = null
      this.$bvModal.show('modal-cadastrar')
    },
    limpaChars (valor) {
      return (valor === null || valor === undefined) ? '' : valor.replace(/ |-|\.|\(|\)|\+/g, '')
    },
    gerarBoletoAvulso: function () {
      this.assinatura.planosIds = [
        ...(this.optPro ? [this.optPro] : []),
        ...(this.optPlanto ? [this.optPlanto] : []),
        ...(this.optKlinico ? [this.optKlinico] : [])
      ]
      this.$v.assinatura.$touch()
      this.$v.opcoes.$touch()

      if (!this.$v.assinatura.$invalid && !this.$v.opcoes.$invalid) {
        const loader = this.$loading.show()

        let assinatura = this.assinatura
        this.assinatura.dadosPessoais.telefone = this.limpaChars(this.assinatura.dadosPessoais.telefone)
        this.assinatura.dadosPessoais.cpf = this.limpaChars(this.assinatura.dadosPessoais.cpf)
        this.assinatura.endereco.cep = this.limpaChars(this.assinatura.endereco.cep)
        this.assinatura.endereco.estado = this.ufs.find(uf => { return uf.id === this.assinatura.endereco.estado }).sigla

        AssinaturaAPI.gerarBoletoAvulso(assinatura).then(data => {
          let links = []
          data.assinatura.forEach(item => {
            if (item.cobrancas.length > 0) {
              let linkBoleto = JSON.parse(item.cobrancas[0].metadado.replace('\\', '').replace('\\', '')).url
              let arrayItem = []
              arrayItem['link'] = linkBoleto
              arrayItem['plano'] = item.plano.plano
              links.push(arrayItem)
            }
          })
          var mensagemBoletos = this.montarLinks(links)
          mensagemBoletos += '<p class="p-2 bg-ligh">O boleto foi enviado para o e-mail do aluno :D</div>'

          loader.hide()
          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            title: 'Assinatura por boleto criada com sucesso',
            html: mensagemBoletos
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('boletoGerado', this.assinatura)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },
    montarLinks: function (links) {
      let msgHtml = '<div>'
      links.forEach((item, indice) => {
        if (item['link']) {
          msgHtml += '<p class="alert alert-light"><a target="_blank" href="' + item['link'] + '">Boleto do ' + item['plano'] + '</a></p>'
        } else {
          msgHtml += '<p class="alert alert-danger">Não foi possível gerar o boleto para o plano ' + item['plano'] + '</p>'
        }
      })
      return msgHtml
    },
    duracao: function (nomePlano) {
      return (nomePlano.split('-')[1])
    },
    buscaAluno: async function () {
      if (this.assinatura.email.length === 0) return

      this.assinatura.dadosPessoais.nome = ''
      this.assinatura.dadosPessoais.cpf = ''
      this.assinatura.endereco.cep = ''
      this.assinatura.endereco.telefone = ''
      this.assinatura.endereco.rua = ''
      this.assinatura.endereco.numero = ''
      this.assinatura.endereco.complemento = ''
      this.assinatura.endereco.bairro = ''
      this.assinatura.endereco.estado = ''
      this.assinatura.endereco.cidade = ''
      this.assinatura.endereco.pais = ''

      const loader = this.$loading.show()

      await UsuarioAPI.obterPorEmail(this.assinatura.email).then(data => {
        this.assinatura.dadosPessoais.nome = data.name
        this.assinatura.dadosPessoais.cpf = data.cpf
        this.assinatura.dadosPessoais.telefone = data.telefone
        this.assinatura.endereco.cep = data.cep
        this.assinatura.endereco.rua = data.rua
        this.assinatura.endereco.numero = data.numero
        this.assinatura.endereco.complemento = data.complemento
        this.assinatura.endereco.bairro = data.bairro
        this.assinatura.endereco.estado = data.uf_id
        this.assinatura.endereco.cidade = data.cidade
        this.assinatura.endereco.pais = 'BR'
      }).catch(error => {
        ResponseUtils.handleError(error, loader)
        return Promise.reject(new Error(400))
      })

      UsuarioAPI.buscaAlunoMundipagg(this.assinatura.email).then(data => {
        loader.hide()
        if (!data.data[0]) return

        if (!data.data[0].address) return

        this.assinatura.dadosPessoais.nome = data.data[0].name
        this.assinatura.dadosPessoais.cpf = data.data[0].document
        this.assinatura.dadosPessoais.telefone = data.data[0].phones.home_phone.country_code + data.data[0].phones.home_phone.area_code + data.data[0].phones.home_phone.number
        this.assinatura.endereco.cep = data.data[0].address.zip_code
        this.assinatura.endereco.rua = data.data[0].address.street
        this.assinatura.endereco.numero = data.data[0].address.number
        this.assinatura.endereco.complemento = data.data[0].address.complement
        this.assinatura.endereco.bairro = data.data[0].address.neighborhood
        this.assinatura.endereco.estado = this.ufs.find(uf => { return uf.sigla === data.data[0].address.state }).id
        this.assinatura.endereco.cidade = data.data[0].address.city
        this.assinatura.endereco.pais = 'BR'
      }).catch(error => {
        ResponseUtils.handleError(error, loader)
      })
    },
    checkPlano: function (index, optPlano, opt, event) {
      if (!event.target.checked) {
        this[opt] = null
        return
      }

      this[opt] = event.target.value
      this[optPlano] = this[optPlano].map(function (item, ix) {
        return ix === index
      })
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
  .radio-planos{
    position: relative;
    top: 25px;
    left: -60px;
  }

  .label-planos{
   text-align: center;
  }
</style>
